import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import * as Ant from "antd";
import { buildClass } from "biuty/react";
import { colors } from "@root/utils/colors";
function Tag({ label, modifiers = "" }) {
    return (_jsx(Ant.Tag, { className: buildClass("tag", modifiers), color: modifiers === "primary" ? colors.selfcityGreen.opacity(0.15) : undefined, children: label }));
}
export default React.memo(Tag);
